import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

export const Theme = definePreset(Material, {
    semantic: {
        primary: 'sky', // Applica l'intera scala Sky (50-950) come primario
        
        // Usiamo Slate per i "Surface" per richiamare i toni freddi dell'acciaio
        surface: 'slate',

        colorScheme: {
            light: {
                primary: {
                    color: '{sky.600}', // Un tono leggermente più scuro per miglior contrasto su bianco
                    inverseColor: '#ffffff',
                    hoverColor: '{sky.700}',
                    activeColor: '{sky.800}'
                }
            },
            dark: {
                primary: {
                    color: '{sky.400}',
                    inverseColor: '{slate.900}',
                    hoverColor: '{sky.300}',
                    activeColor: '{sky.200}'
                }
            }
        }
    }
});